import { FaWhatsapp } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

const WHATSAPP_URL = 'https://wa.me/18763276630?text=Hi%20Paul%21%20I%27d%20appreciate%20your%20help%20with%20something';

export default function WhatsAppFloatingButton() {
  const { pathname } = useLocation();

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with JamPack’d on WhatsApp (opens in a new tab)"
      title="Chat with JamPack’d on WhatsApp"
      className="whatsapp-floating-button"
      data-product-detail={pathname.startsWith('/product/') ? 'true' : undefined}
    >
      <FaWhatsapp aria-hidden="true" className="h-7 w-7" />
    </a>
  );
}
